import PropTypes from "prop-types";
import cx from "classnames";
import BlockContent from "../../blocks/block-content";
import CoreContainer from "../../core-container";
import "./freeform.css";

const Freeform = ({ data = {} }) => {
  const { maxWidth, textAlign, content, moduleWidth, theme } = data;
  const isFullWidth = moduleWidth?.size === "fullWidth";

  return (
    <section className="freeform-module relative mx-auto flex-col justify-end">
      <CoreContainer isFullWidth={isFullWidth} theme={theme?.value} className="z-[1]">
        <BlockContent className={cx("py-6", maxWidth, textAlign)} blocks={content} />
      </CoreContainer>
    </section>
  );
};

Freeform.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.array,
    maxWidth: PropTypes.string,
    textAlign: PropTypes.string,
    theme: PropTypes.shape({
      value: PropTypes.oneOf(["light", "soft", "dark"]),
    }),
    moduleWidth: PropTypes.shape({
      size: PropTypes.string,
    }),
  }),
};

export default Freeform;
